import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService, APP_SETTINGS, AuthService, SpinnerService, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { AdminService } from '../admin.service';
import { environment } from './../../../../environments/environment';
import { NgStyle, NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FroalaEditorModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';

declare var $: any;

@Component({
    selector: 'app-add-new-bulletin',
    templateUrl: './add-new-bulletin.component.html',
    styleUrls: ['./add-new-bulletin.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgStyle, NgIf, FormsModule, NgFor, FroalaEditorModule]
})
export class AddNewBulletinComponent implements OnInit, OnDestroy {

  @ViewChild('recallCampaignFroalaEle')
  public recallCampaignFroalaEle: ElementRef;

  private subscriptions: ISubscription[];
  public expandAccordian = {};

  public errorMessage = '';
  public supportingMaterialserrorMessage = '';
  public supportingVideoserrorMessage = '';
  public faultCodeErrorMessage = "";
  public defectCodeErrorMessage = "";
  public reactivateOrDeactivate;

  public inputBulletinNumber;
  public disableBulletinNumberInput = false;
  public inputSubject;
  public inputPassword = "";
  public expandSection = {};

  public releaseDate;

  public bulletinId;
  makeNameForApi: string = null;

  // binding variables
  public voulantaryEmissionsNumber;
  public voulantaryEmissionsAddInfo;

  public legacyCampingCode;
  public legacyInfo;

  public recallCampaignNumber;
  public recallCampaignAddInfo;

  public serviceActionInfo;

  public startDate;
  public endDate;
  public selStartDate;
  public selEndDate;
  public selReleaseDate;

  public situationInfo;
  public affectedVehiclesInfo;
  public causeInfo;
  public correctionInfo;
  public procedureInfo;
  public partsInfo;
  public warrantyInfo;

  public supportingMaterialsVideo = '';
  public supportingMaterialFile;
  public supportingMaterialFileName = 'No File Selected';
  public supportingMaterialMultipleFileName: string[] = [];
  public supportingMaterialMultipleFile = [];
  public supportingMaterialFileDisplay: any[];
  public isUploadingMultiFiles: boolean;

  /* models section start */
  public allModels: string;
  public seriesFilterList: string[];
  public modelsFilterList: string[];
  public vehicleCodesFilterList: string[];
  public bodiesFilterList: string[];
  public seriesList: string[];
  public modelsList: string[];
  public vehicleCodesList: string[];
  public bodiesList: string[];
  public validAgCodeList: string[];
  public defectFilterList: string[];
  public defectCodesList: string[] = [];
  public faultCodesList: string[];
  public faultCodesFilterList: string[];
  public validFaultCodeList: string[];
  public defectCodesMaster: string[] = [];

  // hold user selection
  public inputBody;
  public inputSeries;
  public inputCode;
  public inputModel;
  /* models section end */
  public inputDefect;

  // froala
  public options: Object;
  public supportingMaterialsOptions: any;
  public partsFroalaContent: any;
  public warrantyFroalaContent: any;
  public supportingMaterialsFroalaContent: any;
  public showAllBulletinOptions: boolean = false;

  public userInput: any;
  // public toggleFindBulletinButton = false;

  private bulletinType: number;
  private completeBulletinDetail: any;
  public bulletinActiveStatus = false;

  private userEmail;

  public mainGroupList: any[] = [];
  public isTakataRecall = false;
  public tkrCode = '';
  public inputGroup;

  public supportingMaterialVideoDisplayNumbers: any[] = [];
  public videoNumbersList: any[] = [];

  public customContent = [];
  public customContentAccordian = {};
  public customContentDescription = {};

  public userRoles = {};

  private makeName = 'BMW';

  // Flags for whether or not Add or Edit API should be called
  public voluntaryEmissionsFlag: boolean = false;
  public recallCampaignFlag: boolean = false;
  public ServiceActionFlag: boolean = false;
  public startEndDatesFlag: boolean = false;
  public modelsFlag: boolean = false;
  public situationFlag: boolean = false;
  public affectedVehiclesFlag: boolean = false;
  public causeFlag: boolean = false;
  public correctionFlag: boolean = false;
  public procedureFlag: boolean = false;
  public partsInformationFlag: boolean = false;
  public warrantyInformationFlag: boolean = false;
  public supportingMaterialsFlag: boolean = false;
  public subjectFlag: boolean = false;

  private isAdmin: boolean = false;
  private isMotorradAdmin: boolean = false;
  private isRollsRoyceAdmin: boolean = false;

  // Disable "save" buttons
  public disableServiceBulletin: boolean = false;

  @ViewChild('agCodeValidationModal')
  public agCodeValidationModal: ElementRef;
  @ViewChild('faultCodeValidationModal')
  public faultCodeValidationModal: ElementRef;

  public invalidCodes = [];
  public agValidation: boolean = true;

  public invalidFaults = [];
  public faultValidation: boolean = true;

  private isMotorrad: boolean = false;
  private mcbinfo = { options: 'mccurrent' };
  public showDefaultBn: boolean = true;
  public showTakata: boolean = false;
  APP_SETTINGS: any;

  constructor(
    private cmsNavbarService: CmsNavbarService,
    private modelMapService: ModelMapService,
    private adminService: AdminService,
    private router: Router,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private toastService: ToastConfigService,
    private userProfileService: UserProfileService,
    private route: ActivatedRoute,
    private changeDetection: ChangeDetectorRef,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscriptions = [];

    if (APP_SETTINGS.isMotorradAdmin === 'true') {
      this.isMotorradAdmin = true;
    }
    if (APP_SETTINGS.isRollsRoyceAdmin === 'true') {
      this.isRollsRoyceAdmin = true;
    }
    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
    }

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
    });

    if (localStorage.getItem('ADMIN_INPUT')) {
      this.userInput = JSON.parse(localStorage.getItem('ADMIN_INPUT'));
      if (this.userInput.action === 'add') {
        this.bulletinType = this.userInput?.contentType?.id;
        this.makeName = this.userInput.make.makeName;
        this.selReleaseDate = this.userInput.date;
        this.releaseDate = this.userInput.date;
        this.isTakataRecall = this.userInput.isTakataRecall;
        this.tkrCode = this.userInput.tkrCode;
      } else if (this.userInput.action === 'edit') {
        this.bulletinType = this.userInput?.contentType?.id;
        this.makeName = this.userInput.make;
      }
    } else if (!localStorage.getItem('ADMIN_INPUT')) {
      // this.cmsNavbarService.userInputs$.subscribe(data => {
      //   this.userInput = data;
      //   this.bulletinType = this.userInput.contentType.id;
      //   this.makeName = this.userInput.action === 'add' ? this.userInput.make.makeName : this.makeName;
      //   localStorage.setItem('ADMIN_INPUT', JSON.stringify(this.userInput));
      //   this.selReleaseDate = this.userInput.date;
      //   this.releaseDate = this.userInput.date;
      //   this.isTakataRecall = this.userInput.isTakataRecall;
      //   this.tkrCode = this.userInput.tkrCode;
      // });
    }
    this.cmsNavbarService.userInputs$.subscribe(data => {
      this.inputBulletinNumber = null;
      this.makeNameForApi = null;
      this.inputSubject = null;
      this.customContent = [];
      this.showAllBulletinOptions = false;
      if (!data && localStorage.getItem('ADMIN_INPUT')) {
        this.userInput = JSON.parse(localStorage.getItem('ADMIN_INPUT'));
      } else {
        this.userInput = data;
      }
      this.bulletinType = this.userInput?.contentType?.id;
      this.makeName = this.userInput.action === 'add' ? this.userInput.make.makeName : this.userInput.make;

      if (this.makeName === 'BMW' || this.makeName === 'MINI') {
        this.showTakata = true;
      } else {
        this.showTakata = false;
      }
      localStorage.setItem('ADMIN_INPUT', JSON.stringify(this.userInput));
      this.selReleaseDate = this.userInput.date;
      this.releaseDate = this.userInput.date;
      this.isTakataRecall = this.userInput.isTakataRecall;
      this.tkrCode = this.userInput.tkrCode;
      this.getVideoNumbers();
    });

    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    }
    else {
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }
    this.initializeModelSectionData();
    this.initializeDefectSectionData();
    this.subscriptions.push(this.modelMapService.getAllModels().subscribe(data => {
      this.modelsList = data;
    }));
    this.subscriptions.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
    }));
    this.subscriptions.push(this.modelMapService.getAllCodes().subscribe(data => {
      this.vehicleCodesList = data;
    }));
    this.subscriptions.push(this.cmsNavbarService.getAllBodiesList().subscribe(data => {
      this.bodiesList = data;
    }));
    //getAllDefectCodes
    this.subscriptions.push(this.modelMapService.getAllDefectCodes().subscribe(data => {
      this.defectCodesList = data;
      //this.defectCodesList = this.defectCodesList.sort(function(a,b) {return b['id'] - a['id']}); //  filter(item=> item['defectCode'].includes('STOP012531')); //this.bodiesFilterList.includes(body['bodyName'])
      this.defectCodesMaster = this.defectCodesList;

    }));

    //getAllFaultCodes
    this.subscriptions.push(this.modelMapService.getAllFaultCodes().subscribe(data => {
      this.faultCodesList = data;
    }));
    this.setFroalaOptions();
  }

  filterDefectCodes(makeName) {
    this.defectCodesList = this.defectCodesMaster;
    if (makeName) {
      switch (makeName) {
        case 'BMW':
          this.defectCodesList = this.defectCodesList.filter(item => item['makeId'] === 31);
          break;
        case 'MINI':
          this.defectCodesList = this.defectCodesList.filter(item => item['makeId'] === 41);
          break;
        case 'MOTORRAD':
          this.defectCodesList = this.defectCodesList.filter(item => item['makeId'] === 51);
          break;
        case 'ROLLSROYCE':
          this.defectCodesList = this.defectCodesList.filter(item => item['makeId'] === 61);
          break;
      }
    }
  }

  getVideoNumbers() {
    this.subscriptions.push(this.adminService.getAllVideoNumbers(this.makeName).subscribe(data => {
      this.videoNumbersList = data;
    }));
  }

  initFroala(initControls) {
    initControls.initialize();
  }

  addToSelection(listType: string, listItem: string) {
    if (listItem) {
      switch (listType) {
        case 'body':
          if (this.bodiesFilterList.filter(item => item === listItem).length === 0) {
            this.bodiesFilterList.push(listItem);
            this.inputBody = '';
          }
          break;
        case 'series':
          if (this.seriesFilterList.filter(item => item === listItem).length === 0) {
            this.seriesFilterList.push(listItem);
            this.inputSeries = '';
          }
          break;
        case 'model':
          if (this.modelsFilterList.filter(item => item === listItem).length === 0) {
            this.modelsFilterList.push(listItem);
            this.inputModel = '';
          }
          break;
        case 'code':
          if (this.vehicleCodesFilterList.filter(item => item === listItem).length === 0) {
            this.vehicleCodesFilterList.push(listItem);
            this.inputCode = '';
          }
          break;
        case 'defects':
          listItem = listItem.replace(/\s/g, "");
          this.checkSpecialChars(listItem, "defect");
          if ((listItem.trim() != "") && this.defectFilterList.filter(item => item === listItem).length === 0) {
            this.defectFilterList = [];
            this.defectFilterList.push(listItem);
            this.inputDefect = '';
          }
          break;

        case 'video':
          if (this.supportingMaterialVideoDisplayNumbers.filter(item => item === listItem).length === 0) {
            this.supportingMaterialVideoDisplayNumbers.push(listItem);
          }
      }
    }
  }

  formatDateForInput(isoDateString: string): string {
    if (!isoDateString) return '';

    const date = new Date(isoDateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  getBulletinDetails(bulletinNumber) {
    this.customContent = [];
    this.errorMessage = '';
    this.spinnerService.show('bmwSpinner');
    this.clearAllErrorMessages();
    this.clearContents();
    this.filterDefectCodes(this.makeNameForApi);
    if (this.bulletinType === 1) {
      this.subscriptions.push(this.adminService.getSIBBulletinDetail(bulletinNumber, this.makeNameForApi).subscribe(
        data => {
          this.completeBulletinDetail = data;
          this.inputSubject = data['bulletin']['description'];
          this.makeName = data['bulletin']['make']['makeName'];
          this.bulletinId = data['bulletin']['id'];
          this.releaseDate = this.formatDateForInput(data['bulletin']['releaseDate'])
          this.userInput.date = data['bulletin']['releaseDate'];
          this.selReleaseDate = data['bulletin']['releaseDate'];
          this.startDate = data['bulletin']['startDate'];
          this.selStartDate = data['bulletin']['startDate'];
          this.endDate = data['bulletin']['endDate'];
          this.selEndDate = data['bulletin']['endDate'];
          this.bulletinActiveStatus = data['bulletin']['isActive'];
          this.isTakataRecall = data['bulletin']['takataRecallType'];
          this.tkrCode = data['bulletin']['takataRecallCode'];
          this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
            if (bulletinDetail['title'] === 'Model(s)') {
              this.seriesFilterList = bulletinDetail['selectedSeries'] ?
                bulletinDetail['selectedSeries'].map(series => series.seriesName) : [];
              this.modelsFilterList = bulletinDetail['selectedModels'] ?
                bulletinDetail['selectedModels'].map(model => model.modelName) : [];
              this.bodiesFilterList = bulletinDetail['selectedBodies'] ? bulletinDetail['selectedBodies'].map(body => body.bodyName) : [];
              this.vehicleCodesFilterList = bulletinDetail['selectedAgCodes'] ?
                bulletinDetail['selectedAgCodes'].map(ageCode => ageCode.agCodeName) : [];
              // this.allModels = bulletinDetail['allModelFlag'];
              // this.allModels = bulletinDetail['allModelFlag'];
            } else if (bulletinDetail['title'] === 'Voluntary Recall Campaign') {
              this.voulantaryEmissionsNumber = bulletinDetail['campaignCode'];
              this.voulantaryEmissionsAddInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Recall Campaign') {
              this.recallCampaignNumber = bulletinDetail['campaignCode'];
              this.recallCampaignAddInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Service Action') {
              this.serviceActionInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Situation') {
              this.situationInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Affected Vehicles') {
              this.affectedVehiclesInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Start and End Dates') {
              // this.affectedVehiclesInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Cause') {
              this.causeInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Correction') {
              this.correctionInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Procedure') {
              this.procedureInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Parts Information') {
              this.partsFroalaContent = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Warranty Information') {
              this.warrantyFroalaContent = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Supporting Materials') {
              // this.supportingMaterialFileName = this.completeBulletinDetail['bulletinFiles'][0].fileName;
              this.supportingMaterialFileDisplay = this.getSupportMaterialFiles(data['bulletinFiles']);
              this.supportingMaterialVideoDisplayNumbers = bulletinDetail['videoDisplayNumber'];
            } else if (bulletinDetail['title'] === 'Legacy') {
              this.legacyInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'DefectCode') {
              this.defectFilterList = bulletinDetail['selectedDefectCodes'] ?
                bulletinDetail['selectedDefectCodes'].map(defect => defect.defectCode) : [];
              this.faultCodesFilterList = bulletinDetail['selectedFaultCodes'] ?
                bulletinDetail['selectedFaultCodes'].map(fault => fault.faultCodeNumber) : [];
            } else {
              this.customContent.push(bulletinDetail);
            }
          });
          this.setFroalaOptions();
          this.showAllBulletinOptions = true;
          this.spinnerService.hide('bmwSpinner');
        },
        err => {
          this.spinnerService.hide('bmwSpinner');
          this.errorMessage = err.error.message;
        }
      ));
      // ELSE is if bulletin is TRI
    } else {
      this.subscriptions.push(this.adminService.getTRIBulletinDetail(bulletinNumber, this.makeNameForApi).subscribe(
        data => {
          this.completeBulletinDetail = data;
          this.inputSubject = data['bulletin']['description'];
          this.bulletinId = data['bulletin']['id'];
          this.userInput.date = data['bulletin']['releaseDate'];
          this.selReleaseDate = data['bulletin']['releaseDate'];
          this.startDate = data['bulletin']['startDate'];
          this.selStartDate = data['bulletin']['startDate'];
          this.endDate = data['bulletin']['endDate'];
          this.selEndDate = data['bulletin']['endDate'];
          this.bulletinActiveStatus = data['bulletin']['isActive'];
          this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
            if (bulletinDetail['title'] === 'Model(s)') {
              this.seriesFilterList = bulletinDetail['selectedSeries'] ?
                bulletinDetail['selectedSeries'].map(series => series.seriesName) : [];
              this.modelsFilterList = bulletinDetail['selectedModels'] ?
                bulletinDetail['selectedModels'].map(model => model.modelName) : [];
              this.bodiesFilterList = bulletinDetail['selectedBodies'] ? bulletinDetail['selectedBodies'].map(body => body.bodyName) : [];
              this.vehicleCodesFilterList = bulletinDetail['selectedAgCodes'] ?
                bulletinDetail['selectedAgCodes'].map(ageCode => ageCode.agCodeName) : [];
              // this.allModels = bulletinDetail['allModelFlag'];
              // this.allModels = bulletinDetail['allModelFlag'];
            } else if (bulletinDetail['title'] === 'Voluntary Recall Campaign') {
              this.voulantaryEmissionsNumber = bulletinDetail['campaignCode'];
              this.voulantaryEmissionsAddInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Recall Campaign') {
              this.recallCampaignNumber = bulletinDetail['campaignCode'];
              this.recallCampaignAddInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Service Action') {
              this.serviceActionInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Situation') {
              this.situationInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Affected Vehicles') {
              this.affectedVehiclesInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Start and End Dates') {
              // this.affectedVehiclesInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Cause') {
              this.causeInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Correction') {
              this.correctionInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Procedure') {
              this.procedureInfo = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Parts Information') {
              this.partsFroalaContent = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Warranty Information') {
              this.warrantyFroalaContent = bulletinDetail['descriptionRich'];
            } else if (bulletinDetail['title'] === 'Supporting Materials') {
              // this.supportingMaterialFileName = this.completeBulletinDetail['bulletinFiles'][0].fileName;
              this.supportingMaterialFileDisplay = this.getSupportMaterialFiles(data['bulletinFiles']);
              this.supportingMaterialVideoDisplayNumbers = bulletinDetail['videoDisplayNumber'];
            } else if (bulletinDetail['title'] === 'Legacy') {
              this.legacyInfo = bulletinDetail['descriptionRich'];
            } else {
              this.customContent.push(bulletinDetail);
            }
          });
          this.setFroalaOptions();
          this.showAllBulletinOptions = true;
          this.spinnerService.hide('bmwSpinner');
        },
        err => {
          this.spinnerService.hide('bmwSpinner');
          this.errorMessage = err.error.message;
        }
      ));
    }
  }
  getSupportMaterialFiles(tempArray: any[]): any[] {
    let tempFile = [];
    for (let i = 0; i < tempArray.length; i++) {
      tempFile.push(tempArray[i].fileName);
    }
    return tempFile;
  }
  createNewBulletin() {
    this.errorMessage = '';
    this.spinnerService.show("bmwSpinner");
    this.filterDefectCodes(this.userInput.make.makeName);
    const bulletinData = {
      'bulletinDisplayNumber': this.inputBulletinNumber,
      'description': this.inputSubject,
      'make': this.userInput.make,
      'mainGroupId': this.userInput.group ? this.userInput.group : -1,
      'releaseDate': this.userInput.date,
      'takataRecallCode': this.userInput.tkrCode,
      'takataRecallType': this.userInput.isTakataRecall

    };

    if (this.userInput.action === 'add' && this.subjectFlag == false) {
      this.clearContents();
      if (this.bulletinType === 1) {
        this.subscriptions.push(this.adminService.createNewSIB(bulletinData, this.makeName).subscribe(data => {
          if (data) {
            this.disableServiceBulletin = true;
            this.errorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.bulletinId = data['id'];
            this.disableBulletinNumberInput = true;
            this.toastService.popToast('Document added');
            localStorage.removeItem('ADMIN_INPUT');
          }
          // Set froala options
          this.setFroalaOptions();
          this.showAllBulletinOptions = true;
          this.subjectFlag = true;
          this.changeDetection.detectChanges();
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.errorMessage = error.error.message;
          }));
      } else {
        this.subscriptions.push(this.adminService.createNewTRI(bulletinData, this.makeName).subscribe(data => {
          if (data) {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = '';
            this.bulletinId = data['id'];
            this.disableBulletinNumberInput = true;
            this.toastService.popToast('Document added');
            localStorage.removeItem('ADMIN_INPUT');
          }
          // Set froala options
          this.setFroalaOptions();
          this.showAllBulletinOptions = true;
          this.changeDetection.detectChanges();
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.errorMessage = error.error.message;
          }));
      }

    } else if (this.userInput.action === 'edit' || this.subjectFlag == true) {
      const bulletin = this.completeBulletinDetail['bulletin'];
      this.bulletinId = bulletin['id'];
      const bulletinUpdateData = {
        'id': bulletin['id'],
        'bulletinDisplayId': this.inputBulletinNumber,
        'bulletinDisplayNumber': this.inputBulletinNumber,
        'description': this.inputSubject,
        'bulletinType': bulletin['bulletinType'],
        'releaseDate': this.releaseDate || bulletin['releaseDate'],
        'updatedDate': bulletin['updatedDate'],
        'isActive': bulletin['isActive'],
        'newBulletin': bulletin['newBulletin'],
        'updatedBulletin': bulletin['updatedBulletin'],
        'savedBulletinGroup': bulletin['savedBulletinGroup'],
        /*
        'takataRecallCode': bulletin['takataRecallCode'],
        'takataRecallType': bulletin['takataRecallType'],*/
        'takataRecallCode': this.tkrCode,
        'takataRecallType': this.isTakataRecall,
        'make': bulletin['make'],
        'mainGroupId': this.userInput.group || bulletin['mainGroupId']
      };
      if (this.bulletinType === 1) {
        this.subscriptions.push(this.adminService.updateSIB(bulletinUpdateData).subscribe(data => {
          if (data) {
            this.errorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            localStorage.removeItem('ADMIN_INPUT');
            // this.disableBulletinNumberInput = true;
            this.toastService.popToast('Document updated');

          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.errorMessage = error.error.message;
          }));
      } else {
        this.subscriptions.push(this.adminService.updateTRI(bulletinUpdateData).subscribe(data => {
          if (data) {
            this.errorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            localStorage.removeItem('ADMIN_INPUT');
            // this.disableBulletinNumberInput = true;
            this.toastService.popToast('Document updated');
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.errorMessage = error.error.message;
          }));
      }
    }
  }

  checkAddEditFlags() {
    this.voluntaryEmissionsFlag = false;
    this.recallCampaignFlag = false;
    this.ServiceActionFlag = false;
    this.startEndDatesFlag = false;
    this.modelsFlag = false;
    this.situationFlag = false;
    this.affectedVehiclesFlag = false;
    this.causeFlag = false;
    this.correctionFlag = false;
    this.procedureFlag = false;
    this.partsInformationFlag = false;
    this.warrantyInformationFlag = false;
    this.supportingMaterialsFlag = false;
  }

  isNewerThan(v1, v2) {
    // TODO check if its being used
    v1 = v1.split('.');
    v2 = v2.split('.');
    for (var i = 0; i < Math.max(v1.length, v2.length); i++) {
      if (v1[i] == undefined) return false; // If there is no digit, v2 is automatically bigger
      if (v2[i] == undefined) return true; // if there is no digit, v1 is automatically bigger
      if (v1[i] > v2[i]) return true;
      if (v1[i] < v2[i]) return false;
    }
    return false; // Returns false if they are equal

  }

  private getFroalaKey(): string {
    return '1CC3kA6A4C4A5F4B3G3cWHNGGDTCWHId1Eb1Oc1Yh1b2Ld1POkE3D3F3A6A4A4D4G3A2I2==';
  }

  private setFroalaOptions(): void {
    const fullToolbar = [
      'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting', '|',
      'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOLSimple', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote', '|',
      'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR', '|',
      'undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'
    ];
    this.options = {
      key: this.getFroalaKey(),
      toolbarButtons: fullToolbar,
      toolbarButtonsMD: fullToolbar,
      toolbarButtonsSM: fullToolbar,
      toolbarButtonsXS: fullToolbar,
      requestHeaders: {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      },
      requestWithCredentials: true,
      charCounterCount: true,
      requestWithCORS: true,
      // Set the image upload parameter.
      imageUploadParam: 'file',
      colorsBackground: [
        '#FFFF00',
        '#61BD6D', '#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC',
        '#41A85F', '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#000000',
        '#F7DA64', '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FFFFFF',
        '#FAC51C', '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8', 'REMOVE'
      ],

      // Set the image upload URL.
      // ~JOSH~ Come back here at some point and make sure that this.inputBulletinNumber is NOT undefined/null before
      // making the API call.
      imageUploadURL: `${environment.baseUrl}common/uploadImage?bulletinNumber=${this.inputBulletinNumber}&makeName=${this.makeName}`,

      // imageUploadURL: `${environment.baseUrl}common/uploadImage`,

      // Additional upload params.
      // imageUploadParams: { bulletinNumber: inputBulletinNumberOnInit, makeName: this.makeName },
      imageUploadParams: {},

      // Delete images
      imageManagerDeleteURL: `${environment.baseUrl}common/deleteImage`,

      // Set request type.
      imageUploadMethod: 'POST',

      // Set max image size to 5MB.
      imageMaxSize: 5 * 1024 * 1024,

      // Allow to upload PNG and JPG.
      imageAllowedTypes: ['jpeg', 'jpg', 'png'],
      fontFamily: {
        "Arial": 'Arial',
        "'Times New Roman',Times,serif": 'Times New Roman',
        "Verdana,Geneva,sans-serif": 'Verdana',
        "'Open Sans Condensed',sans-serif": 'Open Sans Condensed'
      },
      fontFamilyDefaultSelection: "Arial",
      fontFamilySelection: true,
      useClasses: false,
      fontSizeSelection: true

    };
    this.supportingMaterialsOptions = {
      toolbarButtons: ['insertFile']
    };
  }
  reactivateOrDeactivateBulletin() {
    this.spinnerService.show("bmwSpinner");
    const bulletin = this.completeBulletinDetail['bulletin'];
    this.bulletinId = bulletin['id'];
    if (this.reactivateOrDeactivate === 'reactivate') {
      this.adminService.reactivateBulletin(this.bulletinId, this.userEmail, this.makeNameForApi)
        .subscribe(value => {
          this.reactivateOrDeactivate = null;
          this.spinnerService.hide("bmwSpinner");
          this.toastService.popToast('Bulletin Reactivated');
          this.clearAllSectionsData();
          if (this.bulletinType === 1) {
            sessionStorage.removeItem("serviceBulletinsStorageAll");
          }
          else if (this.bulletinType === 2) {
            sessionStorage.removeItem("triBulletinsStorageAll");
          }
        }, error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.errorMessage;
        });
    } else if (this.reactivateOrDeactivate === 'deactivate') {
      this.adminService.deactivateBulletin(this.bulletinId, this.userEmail, this.makeNameForApi)
        .subscribe(value => {
          this.reactivateOrDeactivate = null;
          this.spinnerService.hide("bmwSpinner");
          this.toastService.popToast('Bulletin Deactivated');
          this.clearAllSectionsData();
          if (this.bulletinType === 1) {
            sessionStorage.removeItem("serviceBulletinsStorageAll");
          }
          else if (this.bulletinType === 2) {
            sessionStorage.removeItem("triBulletinsStorageAll");
          }
        }, error => {
          this.spinnerService.hide("bmwSpinner");
          this.errorMessage = error.error.errorMessage;
        });
    }
  }
  addDetailToBulletin(detailInfo) {
    detailInfo = {
      'campaignCode': '',
      'detailType': 'text',
      ...detailInfo
    };
    if (this.bulletinType === 1) {
      this.spinnerService.show('bmwSpinner');
      // tslint:disable-next-line:max-line-length
      this.subscriptions.push(this.adminService.addBulletinDetailsToNewSIB(this.inputBulletinNumber, detailInfo, this.makeName).subscribe(data => {
        if (data) {
          this.spinnerService.hide('bmwSpinner');
          this.toastService.popToast('Document added');
        }
      },
        err => {
          this.spinnerService.hide('bmwSpinner');
          this.errorMessage = err.error.message;
        }));
    } else {
      this.spinnerService.show('bmwSpinner');
      // tslint:disable-next-line:max-line-length
      this.subscriptions.push(this.adminService.addBulletinDetailsToNewTRI(this.inputBulletinNumber, detailInfo, this.makeName).subscribe(data => {
        if (data) {
          this.spinnerService.hide('bmwSpinner');
          this.toastService.popToast('Document added');
        }
      },
        err => {
          this.spinnerService.hide('bmwSpinner');
          this.errorMessage = err.error.message;
        }));
    }
  }
  updateDetailToBulletin(detailInfo) {
    detailInfo = {
      'campaignCode': '',
      'detailType': 'text',
      ...detailInfo
    };
    if (this.bulletinType === 1) {
      this.spinnerService.show('bmwSpinner');
      this.subscriptions.push(this.adminService.updateSIBDetail(detailInfo).subscribe(data => {
        if (data) {
          this.spinnerService.hide('bmwSpinner');
          this.toastService.popToast('Document updated');
        }
      },
        err => {
          this.spinnerService.hide('bmwSpinner');
          this.errorMessage = err.error.message;
        }));
    } else {
      this.spinnerService.show('bmwSpinner');
      this.subscriptions.push(this.adminService.updateTRIBulletinDetails(detailInfo).subscribe(data => {
        if (data) {
          this.spinnerService.hide('bmwSpinner');
          this.toastService.popToast('Document updated');
        }
      },
        err => {
          this.spinnerService.hide('bmwSpinner');
          this.errorMessage = err.error.message;
        }));
    }
  }

  addVoulantaryRecallToBulletin(campaignCode, richContent) {
    this.errorMessage = '';
    const detailData = {
      'title': 'Voluntary Recall Campaign',
      'campaignCode': campaignCode || '',
      'description': this.stripHTML(richContent),
      'descriptionRich': richContent
    };
    if (this.userInput.action === 'add' && this.voluntaryEmissionsFlag == false) {
      this.voluntaryEmissionsFlag = true;
      this.addDetailToBulletin(detailData);
    } else if (this.userInput.action === 'edit' || this.voluntaryEmissionsFlag == true) {
      let updatedInfo = {};
      this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
        if (bulletinDetail['title'] === 'Voluntary Recall Campaign') {
          updatedInfo = bulletinDetail;
        }
      });
      if (Object.keys(updatedInfo).length === 0) {
        this.addDetailToBulletin(detailData);
      } else {
        updatedInfo = {
          ...updatedInfo,
          'descriptionRich': this.voulantaryEmissionsAddInfo,
          'campaignCode': this.voulantaryEmissionsNumber
        };
        this.updateDetailToBulletin(updatedInfo);
      }
    }
  }

  addRecallCampaignToBulletin(campaignCode, richContent) {
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = '';
    const detailData = {
      'title': 'Recall Campaign',
      'campaignCode': campaignCode || '',
      'description': this.stripHTML(richContent),
      'descriptionRich': richContent
    };
    if (this.userInput.action === 'add' && this.recallCampaignFlag == false) {
      this.recallCampaignFlag = true;
      this.addDetailToBulletin(detailData);
    } else if (this.userInput.action === 'edit' || this.recallCampaignFlag == true) {
      let updatedInfo = {};
      this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
        if (bulletinDetail['title'] === 'Recall Campaign') {
          updatedInfo = bulletinDetail;
        }
      });
      if (Object.keys(updatedInfo).length === 0) {
        this.addDetailToBulletin(detailData);
      } else {
        updatedInfo = {
          ...updatedInfo,
          'descriptionRich': this.recallCampaignAddInfo,
          'campaignCode': this.recallCampaignNumber
        };
        this.spinnerService.hide("bmwSpinner");
        this.updateDetailToBulletin(updatedInfo);
      }
    }
  }
  // addDescriptionDetailToBulletin(title, description) {
  //   let detailData = {};
  //   detailData = {
  //     'title': title,
  //     'description': description
  //   };
  //   this.addDetailToBulletin(detailData);
  // }
  addRichDetailToBulletin(title, richContent) {
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = '';
    let detailData = {};
    detailData = {
      // 'title': 'Custom Content',
      'title': title,
      'description': this.stripHTML(richContent),
      'descriptionRich': richContent
    };
    if (this.userInput.action === 'add') {
      this.addDetailToBulletin(detailData);
    } else if (this.userInput.action === 'edit') {
      let updatedInfo = {};
      this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
        if (bulletinDetail['title'] === title) {
          updatedInfo = bulletinDetail;
        }
      });
      if (Object.keys(updatedInfo).length === 0) {
        this.addDetailToBulletin(detailData);
      } else {
        updatedInfo = {
          ...updatedInfo,
          ...detailData
        };
        this.spinnerService.hide("bmwSpinner");
        this.updateDetailToBulletin(updatedInfo);
      }
    }
  }
  stripHTML(htmlContent) {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = htmlContent;
    return tmp.textContent || tmp.innerText || "";
  }
  addModelDataToBulletin() {
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = '';
    let detailData = {};
    const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
    const selectedModel = this.modelsList.filter(model => this.modelsFilterList.includes(model['modelName']));
    const selectedCodes = this.vehicleCodesList.filter(code => this.validAgCodeList.includes((code['agCodeName'] != null && code['agCodeName'].length) ? code['agCodeName'] : 'INVALID'));
    const selectedBodies = this.bodiesList.filter(body => this.bodiesFilterList.includes(body['bodyName']));
    detailData = {
      'title': 'Model(s)',
      'allModelFlag': this.allModels === 'all',
      'excludeModelFlag': this.allModels === 'notAll',
      'selectedModels': selectedModel,
      'selectedSeries': selectedSeries,
      'campaignCode': '',
      'detailType': 'text',
      'selectedAgCodes': selectedCodes,
      'selectedBodies': selectedBodies
    };
    if (this.userInput.action === 'add' && this.modelsFlag == false) {
      this.modelsFlag = true;
      this.addDetailToBulletin(detailData);
    } else if (this.userInput.action === 'edit' || this.recallCampaignFlag == true) {
      let updatedInfo = {};
      this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
        if (bulletinDetail['title'] === 'Model(s)') {
          updatedInfo = bulletinDetail;
        }
      });
      if (Object.keys(updatedInfo).length === 0) {
        this.addDetailToBulletin(detailData);
      } else {
        updatedInfo = {
          ...updatedInfo,
          ...detailData
        };
        this.spinnerService.hide("bmwSpinner");
        this.updateDetailToBulletin(updatedInfo);
        this.vehicleCodesFilterList = this.validAgCodeList;
      }
    }
  }

  addDefectDataToBulletin() {
    if (this.faultCodeErrorMessage === "" && this.defectCodeErrorMessage === "") {
      this.spinnerService.show("bmwSpinner");
      this.errorMessage = '';
      let detailData = {};
      let selectedFault = [];
      selectedFault = this.faultCodesList.filter(code => this.validFaultCodeList.includes((code['faultCodeNumber'] != null && code['faultCodeNumber'].length) ? code['faultCodeNumber'] : 'INVALID'));
      const selectedDefect = this.defectCodesList.filter(defect => this.defectFilterList.includes(defect['defectCode']));
      const selDefect = selectedDefect.map(obj => ({ id: obj['id'], defectCode: obj['defectCode'] }));

      if (this.invalidFaults.length > 0) {
        this.invalidFaults.forEach(element => {
          if (element && element.trim() != "") {
            const newCodes = {
              id: null, faultCodeNumber: element, faultCodeDescription: ""
            };
            selectedFault.push(newCodes);
          }
        });
      }
      if (selDefect.length == 0 && this.defectFilterList.length > 0) {
        this.defectFilterList.forEach(element => {
          const newDefectCodes = {
            id: null, defectCode: element
          };
          selDefect.push(newDefectCodes);
        });
      }
      detailData = {
        'title': 'DefectCode',
        'allModelFlag': false,
        'excludeModelFlag': false,
        'campaignCode': '',
        'detailType': 'text',
        'selectedDefectCodes': selDefect, //selectedDefect,
        'selectedFaultCodes': selectedFault,
        'videoDisplayNumber': null,
        'description': null,
        'descriptionRich': null,
        'selectedSeries': [],
      };
      if (this.userInput.action === 'add') {
        this.addDetailToBulletin(detailData);
      } else if (this.userInput.action === 'edit' || this.recallCampaignFlag == true) {
        let updatedInfo = {};
        this.completeBulletinDetail['bulletinDetail'].forEach(bulletinDetail => {
          if (bulletinDetail['title'] === 'DefectCode') {
            updatedInfo = bulletinDetail;
          }
        });
        if (Object.keys(updatedInfo).length === 0) {
          this.addDetailToBulletin(detailData);
        } else {
          updatedInfo = {
            ...updatedInfo,
            ...detailData
          };
          this.spinnerService.hide("bmwSpinner");
          this.updateDetailToBulletin(updatedInfo);
          //this.faultCodesFilterList = this.validFaultCodeList;
        }
      }
    }
  }

  removeFromSelection(listType: string, listItem: string) {
    switch (listType) {
      case 'body':
        this.bodiesFilterList = this.bodiesFilterList.filter(item => item !== listItem);
        break;
      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem);
        break;
      case 'model':
        this.modelsFilterList = this.modelsFilterList.filter(item => item !== listItem);
        break;
      case 'code':
        this.vehicleCodesFilterList = this.vehicleCodesFilterList.filter(item => item !== listItem);
        break;
      case 'defects':
        this.defectCodeErrorMessage = "";
        this.defectFilterList = this.defectFilterList.filter(item => item !== listItem);
        break;
      case 'supportFile':
        this.supportingMaterialFileDisplay = this.supportingMaterialFileDisplay.filter(item => item !== listItem);
      case 'video':
        this.supportingMaterialVideoDisplayNumbers = this.supportingMaterialVideoDisplayNumbers.filter(item => item !== listItem);
    }
  }
  clearModelData() {
    this.initializeModelSectionData();
  }
  clearAllSectionsData() {
    this.initializeModelSectionData();
    this.initializeDefectSectionData();

    this.inputBulletinNumber = '';
    this.inputSubject = '';
    this.selReleaseDate = this.userInput.date = '';

    this.voulantaryEmissionsNumber = '';
    this.voulantaryEmissionsAddInfo = '';

    this.recallCampaignNumber = '';
    this.recallCampaignAddInfo = '';

    this.selStartDate = '';
    this.selEndDate = '';

    this.serviceActionInfo = '';
    this.situationInfo = '';
    this.affectedVehiclesInfo = '';
    this.correctionInfo = '';
    this.causeInfo = '';
    this.procedureInfo = '';
    this.partsFroalaContent = '';
    this.warrantyFroalaContent = '';

    this.supportingMaterialFileName = '';
    this.supportingMaterialVideoDisplayNumbers = [];

    this.customContent = [];
    this.errorMessage = '';
    this.reactivateOrDeactivate = null;

    this.errorMessage = '';
  }
  // diable models input if 'All Models' is selected
  allModelsSelected() {
    if (this.allModels === 'all') {
      this.modelsFilterList = [];
      this.inputModel = undefined;
    }
  }
  approveBulletin() {
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.adminService.approveBulletin(this.bulletinId).subscribe(data => {
      if (data) {
        this.analyticCallContentAddedUpdated();
        this.clearAllSectionsData();
        this.spinnerService.hide('bmwSpinner');
        this.toastService.popToast('Document Published');
        if (this.userInput.action === 'edit') {
          if (this.bulletinType === 1) {
            sessionStorage.removeItem("serviceBulletinsStorageAll");
          }
          else if (this.bulletinType === 2) {
            sessionStorage.removeItem("triBulletinsStorageAll");
          }
        }
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
      }));
  }

  analyticCallContentAddedUpdated() {
    let userID = this.authService.getUserName();
    if (this.userInput.action === 'add') {
      this.analyticsService.trackNewContentAdded(userID, this.userInput?.contentType?.name, this.makeName, this.inputBulletinNumber, 'added');
    }
    else if (this.userInput.action === 'edit') {
      this.analyticsService.trackEditContentUpdated(userID, this.userInput?.contentType?.name, this.makeName, this.inputBulletinNumber, 'updated');
    }
  }

  downloadPDF() {
    this.spinnerService.show('bmwSpinner');
    this.adminService.downloadBulletinPDF(this.bulletinId).subscribe(data => {
      if (data) {
        const fileURL = URL.createObjectURL(data);
        this.spinnerService.hide('bmwSpinner');
        window.open(fileURL, '_blank');
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
      });
  }

  updateFields() {
    this.userInput.date = this.releaseDate;
    this.userInput.group = this.inputGroup ? this.getOnlyMainGroupCode(this.inputGroup) : this.userInput.group;
  }

  getOnlyMainGroupCode(mainGroup) {
    let mainGroupCode = '';
    if (mainGroup) {
      const matchString = mainGroup.match(/\[(.*?)\]/)[1];
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        mainGroupCode = matchString;
      } else {
        mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
      }
    }
    return mainGroupCode;
  }

  addStartDateEndDateToBulletin() {
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = '';
    let bulletinInfo = {};
    bulletinInfo = {
      'id': this.bulletinId,
      'bulletinDisplayNumber': this.inputBulletinNumber,
      'startDate': this.startDate.formatted,
      'endDate': this.endDate.formatted
    };
    if (this.userInput.action === 'add' && this.startEndDatesFlag == false) {
      this.startEndDatesFlag = true;
      if (this.bulletinType === 1) {
        this.subscriptions.push(this.adminService.addStartAndEndDateToNewSIB(bulletinInfo).subscribe(data => {
          if (data) {
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Dates added');
          }
        }));
      } else {
        this.subscriptions.push(this.adminService.addStartAndEndDateToNewTRI(bulletinInfo).subscribe(data => {
          if (data) {
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Dates added');
          }
        }));
      }
    } else if (this.userInput.action === 'edit' || this.startEndDatesFlag == true) {
      const bulletinUpdateInfo = {
        'id': this.completeBulletinDetail['bulletin']['id'],
        ...bulletinInfo
      };
      if (this.bulletinType === 1) {
        this.subscriptions.push(this.adminService.updateSIB(bulletinUpdateInfo).subscribe(data => {
          if (data) {
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Dates updated');
          }
        }));
      } else {
        this.subscriptions.push(this.adminService.addStartAndEndDateToNewTRI(bulletinUpdateInfo).subscribe(data => {
          if (data) {
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Dates updated');
          }
        }));
      }
    }
  }
  initializeModelSectionData() {
    this.seriesFilterList = [];
    this.modelsFilterList = [];
    this.vehicleCodesFilterList = [];
    this.bodiesFilterList = [];
    this.inputSeries = this.inputModel = this.inputCode = this.inputBody = this.allModels = undefined;
  }

  initializeDefectSectionData() {
    this.defectFilterList = [];
    this.faultCodesFilterList = [];
    this.defectCodeErrorMessage = "";
    this.faultCodeErrorMessage = "";
  }

  addSupportingVideos() {
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = '';
    const formData = new FormData();
    formData.append('campaignCode', '');
    formData.append('detailType', 'text');
    this.supportingMaterialVideoDisplayNumbers.forEach(videoNumber => {
      formData.append('videoNumberOrTitle', videoNumber);
    });

    if (this.bulletinType === 1) {
      this.subscriptions.push(this.adminService.addSupportingVideosToNewSIB(this.bulletinId, formData, this.makeName)
        .subscribe(data => {
          if (data) {
            this.supportingVideoserrorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Supporting Videos updated');
            //this.supportingMaterialsVideo = '';
            //this.supportingMaterialVideoDisplayNumbers = [];
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.supportingVideoserrorMessage = error.error.message;
          }));
    } else {
      this.subscriptions.push(this.adminService.addSupportingVideosToNewTRI(this.bulletinId, formData, this.makeName)
        .subscribe(data => {
          if (data) {
            this.supportingVideoserrorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Supporting Videos updated');
            //this.supportingMaterialsVideo = '';
            // this.supportingMaterialVideoDisplayNumbers = [];
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.supportingVideoserrorMessage = error.error.message;
          }));
    }
  }

  addSupportingMaterials(title, videoId) {
    this.spinnerService.show("bmwSpinner");
    this.errorMessage = '';
    const formData = new FormData();
    // Add class to remove file names here
    // this.supportingMaterialFileDisplay.forEach(fileNumber => {


    Object.keys(this.supportingMaterialMultipleFile).forEach(key => {
      formData.append('bulletinFile', this.supportingMaterialMultipleFile[key], this.supportingMaterialMultipleFileName[key]);
    });


    // formData.append('videoNumberOrTitle', videoId);
    formData.append('campaignCode', '');
    formData.append('detailType', 'text');
    /* Removing video from here
    this.supportingMaterialVideoDisplayNumbers.forEach(videoNumber => {
      formData.append('videoNumberOrTitle', videoNumber);
    });*/

    if (this.bulletinType === 1) {
      this.subscriptions.push(this.adminService.addSupportingMaterialsToNewSIB(this.bulletinId, formData, this.makeName)
        .subscribe(data => {
          if (data) {
            this.supportingMaterialserrorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Supporting Materials added');
            if (this.userInput.action === 'add') {
              this.supportingMaterialFile = null;
              this.supportingMaterialFileName = '';
              this.supportingMaterialFileDisplay = [];
              this.supportingMaterialMultipleFileName = [];
              this.supportingMaterialMultipleFile = [];
            }
            /*
            this.supportingMaterialsVideo = '';
            this.supportingMaterialVideoDisplayNumbers = [];
            */
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.supportingMaterialserrorMessage = error.error.message;
          }));
    } else {
      this.subscriptions.push(this.adminService.addSupportingMaterialsToNewTRI(this.bulletinId, formData, this.makeName)
        .subscribe(data => {
          if (data) {
            this.supportingMaterialserrorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('Supporting Materials added');

            if (this.userInput.action === 'add') {
              this.supportingMaterialFile = null;
              this.supportingMaterialFileName = '';
              this.supportingMaterialFileDisplay = [];
              this.supportingMaterialMultipleFileName = [];
              this.supportingMaterialMultipleFile = [];
            }
            /*
            this.supportingMaterialsVideo = '';
            this.supportingMaterialVideoDisplayNumbers = [];
            */
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.supportingMaterialserrorMessage = error.error.message;
          }));
    }
  }
  addCustomContent() {
    const customContentObj = { 'title': 'Custom Content', 'descriptionRich': '' };
    this.customContent.push(customContentObj);
  }
  fileUpload(fileObj) {
    if (!fileObj)
      return

    const files = fileObj.target.files;

    for (let i = 0; i < files.length; i++) {
      if (this.supportingMaterialFile == null) {
        this.supportingMaterialFile = [];
      }
      const name = files[i].name;
      let foundIt = 0;
      for (let j = 0; j < this.supportingMaterialFile.length; j++) {
        if (this.supportingMaterialFile[j].name === name) {
          foundIt = 1;
          break;
        }
      }

      if (foundIt === 0) {
        this.supportingMaterialMultipleFileName.push(files[i].name);
        this.supportingMaterialMultipleFile.push(files[i]);
      }
    }
    this.isUploadingMultiFiles = true;
  }
  formatBulletinNumber(event: any) {
    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput = this.inputBulletinNumber;
    let split = 2;
    let chunk = [];
    tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    for (let i = 0; i < this.inputBulletinNumber.length; i += split) {
      chunk.push(tempInput.substr(i, split));
    }
    tempInput = chunk.join(' ').trim();
    this.inputBulletinNumber = tempInput.slice(0, 8);
  }
  checkBulletinLength() {
    if (this.inputBulletinNumber == undefined) {
      return true;
    }
    if (this.inputBulletinNumber.length == 8) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

  deleteSupportingDocuments() {

    if (this.bulletinType === 1) {
      this.subscriptions.push(this.adminService.deleteSIBSupportDocuments(this.bulletinId, this.makeName)
        .subscribe(data => {
          if (data) {
            this.supportingMaterialserrorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('All Supporting Materials deleted');
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.supportingMaterialserrorMessage = error.error.message;
          }));
    } else {
      this.subscriptions.push(this.adminService.deleteTRISupportDocuments(this.bulletinId, this.makeName)
        .subscribe(data => {
          if (data) {
            this.supportingMaterialserrorMessage = '';
            this.spinnerService.hide("bmwSpinner");
            this.toastService.popToast('All Supporting Materials deleted');
          }
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.supportingMaterialserrorMessage = error.error.message;
          }));
    }
  }

  validateModelCodes(listItem) {
    let codes = [];
    let modelArray = [];
    this.invalidCodes = [];
    this.agValidation = true;
    this.validAgCodeList = [];

    //GET ENTERED AG_CODES FROM TEXTAREA - NEW CODE LIST
    /* if (this.vehicleCodesFilterList.filter(item => item === listItem).length === 0) {
      this.vehicleCodesFilterList.push(listItem);
    } */
    codes = listItem.indexOf(',') > 0 ? listItem.split(',') : listItem;

    //ADD ALL AG_CODES INTO ARRAY FROM VEHICLE_LIST - EXISTING CODE LIST
    this.vehicleCodesList.forEach(element => {
      if (element.hasOwnProperty('agCodeName')) {
        modelArray.push(element['agCodeName']);
      }
    });

    //COMPARE NEW CODES WITH EXISTING
    if (typeof (codes) == 'object') {
      codes.forEach(element => {
        if (modelArray.indexOf(element) > 0) {
          this.validAgCodeList.push(element);
        } else {
          this.invalidCodes.push(element);
          this.agValidation = false;
        }
      });
    } else {
      if (modelArray.indexOf(codes) > 0) {
        this.validAgCodeList.push(codes);
      } else {
        this.invalidCodes.push(codes);
        this.agValidation = false;
      }
    }

    this.agCodeValidationModal.nativeElement.click();
  }

  checkSpecialChars(listItem, code) {
    if (code === "fault") {
      const format = /^(?:0X)?0*(([S|P]?)([0-9a-fA-F]{1,8}))$/; ///[!@#$%^&*()_+\-=\[\]{};':"\\|.~`<>\/?]+/; //w/o comma ,   
      this.faultCodeErrorMessage = "";
      if (typeof (listItem) !== 'object') {
        if (format.test(listItem)) {
          this.faultCodeErrorMessage = "";
        }
        else {
          this.faultCodeErrorMessage = "Fault Code entered is invalid.";
        }
      }
      else {
        for (let i = 0; i < listItem.length; i++) {
          listItem[i] = listItem[i].replace(/\s/g, "");
          if (format.test(listItem[i])) {
            this.faultCodeErrorMessage = "";
          }
          else {
            if (listItem[i] !== "") {
              this.faultCodeErrorMessage = "Fault Code entered is invalid.";
              break;
            }
          }
        }
      }
    }
    else if (code === "defect") {
      const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|.,~`<>\/?]+/;
      this.defectCodeErrorMessage = "";
      if (format.test(listItem)) {
        this.defectCodeErrorMessage = "Defect Codes does not accept special characters.";
      }
      else {
        this.defectCodeErrorMessage = "";
      }
    }
  }

  validateDefectCodes(listItem) {
    let codes = [];
    let modelArray = [];
    this.invalidFaults = [];
    this.faultValidation = true;
    this.validFaultCodeList = [];


    codes = listItem.indexOf(',') > 0 ? listItem.split(',') : listItem;
    this.checkSpecialChars(codes, "fault");

    //codes = listItem.indexOf(',') > 0 ? listItem.split(',') : listItem;
    if (codes && codes.length > 0) {
      this.faultCodesFilterList = codes;
    }


    //ADD ALL AG_CODES INTO ARRAY FROM VEHICLE_LIST - EXISTING CODE LIST
    this.faultCodesList.forEach(element => {
      if (element.hasOwnProperty('faultCodeNumber')) {
        modelArray.push(element['faultCodeNumber']);
      }
    });

    //COMPARE NEW CODES WITH EXISTING
    if (typeof (codes) == 'object') {
      codes.forEach(element => {
        if (modelArray.indexOf(element) > 0) {
          this.validFaultCodeList.push(element);
        } else {
          this.invalidFaults.push(element);
          //this.faultValidation = false;
        }
      });
    } else {
      if (modelArray.indexOf(codes) > 0) {
        this.validFaultCodeList.push(codes);
      } else {
        this.invalidFaults.push(codes);
        //this.faultValidation = false;
      }
    }

    if (this.faultCodeErrorMessage === "" && this.defectCodeErrorMessage === "") {
      //this.faultCodeValidationModal.nativeElement.click(); 
    }
  }

  clearAllErrorMessages() {
    this.supportingVideoserrorMessage = "";
    this.supportingMaterialserrorMessage = "";
    this.errorMessage = "";
    this.faultCodeErrorMessage = "";
    this.defectCodeErrorMessage = "";
  }

  clearContents() {
    this.supportingMaterialsVideo = '';
    this.supportingMaterialFile = '';
    this.supportingMaterialFileName = 'No File Selected';
    this.supportingMaterialMultipleFileName = [];
    this.supportingMaterialMultipleFile = [];
    this.supportingMaterialFileDisplay = [];
    this.legacyInfo = '';
    this.seriesFilterList = [];
    this.modelsFilterList = [];
    this.bodiesFilterList = [];
    this.vehicleCodesFilterList = [];
    this.supportingMaterialVideoDisplayNumbers = [];
    this.defectFilterList = [];
    this.faultCodesFilterList = [];
  }

  private handleMcbInfoChange(event) {
    if (event.target.value === 'mccurrent') {
      this.showDefaultBn = true;
    } else if (event.target.value === 'mclegacy') {
      this.showDefaultBn = false;
    }
  }

  private handleGroupChange(event) {
    if (event.target.value === 'BMW' || event.target.value === 'MINI') {
      this.showDefaultBn = true;
      this.showTakata = true;
    } else if (event.target.value === 'MOTORRAD' || event.target.value === 'ROLLSROYCE') {
      this.showTakata = false;
    }
  }
}